/**
 * Progress notes shown to customers on order timeline.
 * Return reason on return_requested; approve / reject / refund (latest only).
 */

const SYSTEM_NOTE_PATTERNS = [
  /^status changed from /i,
  /^marked (ready|out for|delivered|collected)/i,
  /^order placed/i,
  /^payment confirmed/i,
  /^started processing/i,
  /^full refund processed/i,
];

const RETURN_REQUESTED_NOTE = /^return requested:\s*/i;

export function isSystemProgressNote(note) {
  const text = String(note || "").trim();
  if (!text) return true;
  if (RETURN_REQUESTED_NOTE.test(text)) return false;
  return SYSTEM_NOTE_PATTERNS.some((re) => re.test(text));
}

export function isCustomerFacingProgressEntry(entry, history = [], index = -1) {
  if (!entry) return false;

  if (entry.status === "return_requested") {
    const note = String(entry.note || "").trim();
    return Boolean(note);
  }

  if (entry.customerVisible === true && !isSystemProgressNote(entry.note)) {
    return true;
  }
  if (isSystemProgressNote(entry.note)) return false;

  const status = entry.status;
  if (status === "returned" || status === "refunded") return true;

  if (status === "delivered" && index > 0) {
    const prev = history[index - 1];
    if (prev?.status === "return_requested") return true;
  }

  return false;
}

export function getProgressRemarkForEntry(history, index) {
  if (!Array.isArray(history) || index < 0 || index >= history.length) {
    return null;
  }

  const entry = history[index];
  if (entry?.status === "return_requested") {
    const note = String(entry.note || "").trim();
    if (!note) return null;
    return note.replace(RETURN_REQUESTED_NOTE, "").trim() || note;
  }

  let lastVisibleIndex = -1;
  for (let i = 0; i < history.length; i++) {
    const e = history[i];
    if (e?.status === "return_requested") continue;
    if (isCustomerFacingProgressEntry(e, history, i)) {
      lastVisibleIndex = i;
    }
  }

  if (index !== lastVisibleIndex) return null;
  const note = String(history[index]?.note || "").trim();
  return note || null;
}
